import React from 'react';
import {
  Grid,
  Typography,
  Card,
  CardHeader,
  CardContent,
  Avatar,
  ListItem,
  ListItemIcon,
  ListItemText,
  makeStyles,
} from '@material-ui/core';
import featureGroups from '../../../utils/featureGroups';

import styles from './styles';

const useStyles = makeStyles(styles);

const FeatureHighlightsComponent = () => {
  const classes = useStyles();

  return (
    <Grid container spacing={2} className={classes.featureGroupContainer}>
      <Grid item xs={12}>
        <Typography align="center" gutterBottom>View full feature details from the <a href="https://pingum.io/features" rel="noopener noreferrer" target="_blank">features page</a>.</Typography>
      </Grid>
      { featureGroups.map((featureGroup) => (
        <Grid key={featureGroup.name} item xs={12} sm={6} md={4} lg={3}>
          <Card className={classes.card}>
            <CardHeader
              classes={{ root: classes.cardHeader }}
              avatar={(
                <Avatar>
                  {featureGroup.icon}
                </Avatar>
              )}
              titleTypographyProps={{ variant: 'h4' }}
              title={featureGroup.name}
              subheader={featureGroup.description}
            />
            <CardContent>
              {featureGroup.features.map((feature) => (
                <ListItem key={feature.name} dense>
                  <ListItemIcon>
                    {feature.icon}
                  </ListItemIcon>
                  <ListItemText
                    primary={feature.name}
                  />
                </ListItem>
              ))}
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};
FeatureHighlightsComponent.propTypes = {};

FeatureHighlightsComponent.defaultProps = {};

export default FeatureHighlightsComponent;
